import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex w-100 align-items-center gap-4 p-2" }
const _hoisted_2 = {
  key: 1,
  class: "bi bi-exclamation-circle-fill",
  style: {"color":"var(--cor_layout_1) !important","font-size":"30px"}
}
const _hoisted_3 = { class: "text-start p-0 my-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-start p-0 my-1",
  style: {"font-weight":"300","font-size":"11px","opacity":"0.7"}
}
const _hoisted_5 = {
  key: 0,
  style: {"margin-left":"-16px","margin-right":"-16px","opacity":"0.1"}
}
const _hoisted_6 = {
  key: 1,
  style: {"margin-left":"-16px","margin-right":"-48px","opacity":"0.1"}
}
const _hoisted_7 = { class: "dialog-footer d-flex justify-content-end gap-3 w-100" }
const _hoisted_8 = ["disabled", "data-kt-indicator"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Sair", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Aguarde... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["disabled", "data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Cancelar", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Aguarde... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["disabled", "data-kt-indicator"]
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Aguarde... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

import { computed, ref, watch } from 'vue'
import { useStore } from "vuex"
import { Actions } from "@/store/enums/StoreEnums"

/** Config */

export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'RequiredCheckModal',
},
  __name: 'RequiredCheckModal',
  props: {
  enabled: {
    type: Boolean,
    required: true
  },
  logoutBtnEnabled: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: "Atualizações pendentes"
  },
  subTitle: {
    type: String,
    default: ""
  },
  executeBtnName: {
    type: String,
    required: true
  },
  executeBtnDisabled: {
    type: Boolean,
    required: true
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: "500px"
  },
  footerBtnWidth: {
    type: String,
    defaut: 'auto'
  },
  onExecuteClick: {
    type: Function,
    default: () => window.alert("Passe um callback aqui! :D")
  }
},
  emits: ['disabled'],
  setup(__props, { emit: __emit }) {



const props = __props

const emit = __emit

/** Variables */
const store = useStore();
const showModal = ref(false)
const styleDialog = computed(() => ({
  maxWidth: props.width,
}))
const styleFooterBtn = computed(() => ({
  width: props.footerBtnWidth
}))

/** Methods */
const handleToggleModal = (toggle: boolean) => showModal.value = toggle

const closeModal = () => showModal.value = false

const logout = async() => {
  closeModal()
  store.dispatch(Actions.LOGOUT);
}

const handleExecuteClick = () => {
  if (props.onExecuteClick)
    props.onExecuteClick()
};

/** Life Cycles */
watch(() => props.enabled, (value) => handleToggleModal(value), { immediate: true })

watch(() => showModal.value, (value) => {
  if (!value)
    emit('disabled')
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    title: __props.title,
    width: "100%",
    style: _normalizeStyle(styleDialog.value),
    "close-on-click-modal": false,
    "show-close": !__props.logoutBtnEnabled
  }, {
    header: _withCtx(({ close, titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.$slots.headerIcon)
          ? _renderSlot(_ctx.$slots, "headerIcon", { key: 0 })
          : (_openBlock(), _createElementBlock("i", _hoisted_2)),
        _createElementVNode("span", null, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.title), 1),
          (__props.subTitle)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_4, _toDisplayString(__props.subTitle), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (__props.logoutBtnEnabled)
        ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
        : (_openBlock(), _createElementBlock("hr", _hoisted_6))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        (__props.logoutBtnEnabled)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: logout,
              class: _normalizeClass(["btn background_btn_1_opct btn-sm", { disabled: __props.isLoading }]),
              disabled: __props.isLoading,
              "data-kt-indicator": __props.isLoading ? 'on' : 'off',
              style: _normalizeStyle(styleFooterBtn.value)
            }, _hoisted_11, 14, _hoisted_8))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: closeModal,
              class: _normalizeClass(["btn background_btn_1_opct btn-sm", { disabled: __props.isLoading }]),
              disabled: __props.isLoading,
              "data-kt-indicator": __props.isLoading ? 'on' : 'off',
              style: _normalizeStyle(styleFooterBtn.value)
            }, _hoisted_15, 14, _hoisted_12)),
        _createElementVNode("button", {
          onClick: handleExecuteClick,
          class: _normalizeClass(["btn background_btn_1 btn-sm text-white", { disabled: __props.isLoading }]),
          disabled: __props.executeBtnDisabled || __props.isLoading,
          "data-kt-indicator": __props.isLoading ? 'on' : 'off',
          style: _normalizeStyle(styleFooterBtn.value)
        }, [
          _createElementVNode("span", _hoisted_17, [
            _renderSlot(_ctx.$slots, "executeBtnIcon"),
            _createTextVNode(_toDisplayString(__props.executeBtnName), 1)
          ]),
          _hoisted_18
        ], 14, _hoisted_16)
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["modelValue", "title", "style", "show-close"]))
}
}

})